import { TranslationLabels } from "translations/TranslationLabels";

export enum MeetingStatusEnum {
  None = -1,
  Unknown = 0,
  Default = 1,
  Published = 2,
  Complete = 3,
  Archived = 4,
  Deleted = 5,
}

/**
 * Gets the localized label for a MeetingStatusEnum value.
 */
export function getMeetingStatusLabel(value: MeetingStatusEnum, i18n: TranslationLabels): string {
  switch (value) {
    case MeetingStatusEnum.None:
      return i18n.MeetingStatus_Unknown;
    case MeetingStatusEnum.Unknown:
      return i18n.MeetingStatus_Unknown;
    case MeetingStatusEnum.Default:
      return i18n.MeetingStatus_Default;
    case MeetingStatusEnum.Published:
      return i18n.MeetingStatus_Published;
    case MeetingStatusEnum.Complete:
      return i18n.MeetingStatus_Complete;
    case MeetingStatusEnum.Archived:
      return i18n.MeetingStatus_Archived;
    case MeetingStatusEnum.Deleted:
      return i18n.MeetingStatus_Deleted;
    default:
      return `Unknown MeetingStatusEnum: ${value}`;
  }
}
